import { Component, OnInit, OnDestroy, inject, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ActionRecorderService } from 'src/app/services/action-recorder.service';
import { SelectModule } from 'primeng/select';
import { ToastService } from 'src/app/toast/toast.service';
import { TestRecorderViewModel } from '../../viewmodels/test-recorder.viewmodel';
import { FluidModule } from 'primeng/fluid';
import { ScenarioService } from '../../../scenario/services/scenario.service';
import { StepsService } from '../../../steps/services/steps.service';
import { StepPlaceholderService } from 'src/app/services/step-placeholder.service';
import { ScreenMasterService } from '../../../screen-master/services/screen-master.service';
import { SkeletonService } from '../../../../services/skeleton.service';
import { AuthService } from '../../../../auth/login/services/auth.service';

@Component({
  selector: 'app-test-recorder',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    CardModule,
    ChipModule,
    TagModule,
    TooltipModule,
    FluidModule,
    ConfirmDialogModule,
    SelectModule
  ],
  providers: [ConfirmationService, ToastService],
  templateUrl: './test-recorder-list.component.html',
  styleUrls: ['./test-recorder-list.component.scss']
})
export class TestRecorderListComponent implements OnInit, OnDestroy {
  public viewModel!: TestRecorderViewModel;

  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  private actionRecorder = inject(ActionRecorderService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private ngZone = inject(NgZone);
  private scenarioService = inject(ScenarioService);
  private stepsService = inject(StepsService);
  private stepPlaceholderService = inject(StepPlaceholderService);
  private screenMasterService = inject(ScreenMasterService);
  private authService = inject(AuthService);
  private skeletonService = inject(SkeletonService);

  ngOnInit(): void {
    this.viewModel = new TestRecorderViewModel(
      this.http,
      this.toastService,
      this.confirmationService,
      this.actionRecorder,
      this.router,
      this.route,
      this.ngZone,
      this.scenarioService,
      this.stepsService,
      this.stepPlaceholderService,
      this.screenMasterService,
      this.authService,
      this.skeletonService
    );
    this.viewModel.init();
  }

  ngOnDestroy(): void {
    this.viewModel.destroy();
  }


}
